<template>
    <autocomplete
            v-model="selectedCity"
            :get-label="getLabel"
            :items="cities"
            :component-item="itemTemplate"
            @update-items="search"
            :wait="400"
            :min-len="0"
            :auto-select-one-item="false"
            :input-attrs="inputAttrs"/>
</template>

<script>
    import Autocomplete from 'v-autocomplete';
    import 'v-autocomplete/dist/v-autocomplete.css';
    import CityPickerTemplate from '@/components/CityPickerTemplate';

    export default {
        name: "CityPicker",

        props: ['value', 'forwardValue', 'label'],

        components: {
            Autocomplete, CityPickerTemplate
        },

        data() {
            return {
                inputAttrs: {
                    id: 'citySearch-' + this.$uuid.v1(),
                    autocomplete: 'off',
                    required: true
                },
                itemTemplate: CityPickerTemplate,
                cities: [],
                // Если непустое, значит, нужно прокидывать значение наверх для v-model,
                // иначе - записывать в sweph store
                internalSelectedCity: null
            }
        },

        created() {
            if (!!this.value)
                this.selectedCity = this.value;
        },

        watch: {
            value(val) {
                this.internalSelectedCity = val;
            },

            internalSelectedCity(val) {
                // Проброс значения наверх для v-model
                this.$emit('input', val);
            }
        },

        computed: {
            selectedCity: {
                get() {
                    return !this.forwardValue ?
                            this.$store.getters.inputCity :
                            this.internalSelectedCity;
                },

                set(city) {
                    if (!!city && !!city.dummy) {
                        city = null;
                    }

                    if (!this.forwardValue) {
                        this.$store.commit('setInputCity', city);
                    } else {
                        this.internalSelectedCity = city;
                    }
                }
            },
        },

        methods: {
            // sortByName(item) {
            //     return (item || '').toLowerCase().indexOf((this.search || '').toLowerCase()) > -1
            // },

            getLabel(city) {
                return city ? city.name : null;
            },

            async search(text) {
                if (!text || text.length < 2) {
                    // Хак на замену параметра min-len у v-autocomplete:
                    // При min-len="2" список подсказок не затирается, если сначала ввели >2 символолв, и показались результаты,
                    // а затем стираем строку до < 2 символов.
                    this.cities = [];
                    return;
                }

                let cities = await this.$store.dispatch('loadCitiesByName', text);
                if (!!cities && cities.length > 0) {
                    this.cities = cities;
                } else {
                    this.cities = [{
                        dummy: true
                    }];
                }
            }
        },

        mounted() {
            let labelText = this.label && this.label.length > 0 ? this.label :
                    'Место рождения';

            let citySearchLabel = document.createElement('label');
            citySearchLabel.innerHTML = labelText;
            let citySearch = document.getElementById(this.inputAttrs.id);
            citySearch.parentNode.insertBefore(citySearchLabel, citySearch.nextSibling);
        }
    }
</script>
